module.exports = __webpack_public_path__ + "9b2f87eb22bc4a09e606c84532a97900.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Aside/images/bio-leo-03.jpg
 ** module id = 356
 ** module chunks = 0
 **/